// extracted by mini-css-extract-plugin
module.exports = {"pill":"_37zuf3ao","selected":"_1254qY1i","clear":"_16muFxy6","bold":"eCeJBYWJ","selectedPill":"_39G2GHjE"};